import React from 'react';
import Loader from '../../components/common/Loader';
import Footer from '../../components/home1/Footer';
import Menu from '../../components/innerpage/Menu';
import StartButton from '../../components/home5_residence/StartButton';
import Project from '../../components/innerpage/single_project/Project';
import Testimonials from '../../components/innerpage/single_project/Testimonials';
import RelatedProjects from '../../components/innerpage/single_project/RelatedProjects';
import Chat from '../../components/innerpage/single_project/Chat';
import { Helmet } from 'react-helmet';
import Navbar from "../../components/innerpage/Navbar";

function Aktoprak() {
  return (
      <>
        <Helmet>
          <title>Villa Moda | Lüks ve Doğayla İç İçe Yaşam</title>
          <meta
              name="description"
              content="Aktoprak Villaları, doğanın kalbinde modern yaşam alanları sunar. Geniş bahçeler, akıllı ev sistemleri ve yüksek güvenlik ile elit bir yaşam sizi bekliyor."
          />
          <meta
              name="keywords"
              content="Aktoprak Villaları, Gaziantep villa projeleri, doğa içi yaşam, lüks konut, akıllı ev, müstakil villa"
          />
          <link
              rel="stylesheet"
              type="text/css"
              href="/innerpages/assets/css/innerpages.css"
          />
          <script src="/common/assets/js/common_js.js"></script>
          <script src="/innerpages/assets/js/innerpages.js"></script>
        </Helmet>

        <body className="inner-pages-style1 s-project-pg-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
            <Navbar />
          <main>
            {/* Project bileşeninde: Aktoprak Villaları'nın lokasyonu, villa detayları, metrekare bilgisi, planlar */}
            <Project />
            {/* Testimonials bileşeninde: Aktoprak'ta yaşayanların deneyimlerinden alıntılar */}
              {/*<Testimonials/>*/}
          {/*   RelatedProjects bileşeninde: Benzer villa projeleri ya da çevredeki lüks projeler
            <RelatedProjects />*/}
            {/* Chat bileşeninde: Aktoprak Villaları hakkında anında bilgi alın */}
            <Chat />
          </main>
          <Footer />
        </div>
        <StartButton />
        </body>
      </>
  );
}

export default Aktoprak;